import { render, staticRenderFns } from "./epms5040.vue?vue&type=template&id=68dccd25&scoped=true"
import script from "./epms5040.vue?vue&type=script&lang=js"
export * from "./epms5040.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dccd25",
  null
  
)

export default component.exports